














































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
// import CardModalSKDP from "@/components/modal/CardModalSKDP.vue";
import CardInputSKDP from "@/components/pemeriksaan/resumeSuketV2/CardInputSKDP.vue";
import { PrefillSkdp } from "@/types/resumeRalanBlanko";

// import CardModalKasusSkdp from "@/components/modal/CardModalKasusSkdp.vue";
import CardModalKasusSkdp from "@/components/pemeriksaan/resumeSuketV2/CardModalKasusSkdp.vue";
import DataSKDP from "@/services/DataSKDP";
import { storeSoap } from "@/store/modules/soap";
import { storeSKDP } from "@/store/modules/skdp";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import moment from "moment";
import http from "@/axios/http-common";
import Skdp from "@/services/new/Skdp";
import SuratKonsulRujukInternalStore from "@/store/modules/SuratKonsulRujukInternalStore";
import { storeKonsul } from "@/store/modules/konsul";

@Component({
  components: {
    CardModalTtd,
    // CardModalSKDP,
    CardInputSKDP,
    CardModalKasusSkdp
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardSKDP extends Vue {
  @Prop() readonly register!: string;
  @Prop() expandInput!: boolean;
  @Prop({ default: null }) readonly prefill!: PrefillSkdp | null;
  @Prop({ default: null }) readonly prefillNonce!: number | null;
  isReadOnly!: () => boolean;

  get readOnlyMode(): boolean {
    return this.isReadOnly();
  }

  sess_login = this.stateuser;
  modalTtd = false;
  modalSKDP = false;
  modalKasusSkdp = false;
  pageTab = "tab-soap";
  dataSkdp = {};
  kronis = false;
  prefillAktif: PrefillSkdp | null = null;
  bukaDariPrefill = false;

  get stateSkdp() {
    return storeSKDP.data;
  }
  get stateDataSkdp() {
    return storeSKDP.skdp;
  }

  // get stateDetailSkdp() {
  //   return storeSKDP.detailSkdp;
  // }

  get dataDetailSkdp() {
    return storeSKDP.datadetailSkdp;
  }

  get stateInputSkdp() {
    return storeSKDP.inputSkdp;
  }

  get statesoapdetail() {
    return storeSoap.detailSoap;
  }
  get statesoapdata() {
    return storeSoap.soap;
  }

  get stateuser() {
    return userModule.user;
  }

  get canEdit() {
    if (this.readOnlyMode) return false;
    return (
      this.stateuser.profesi == "Dokter" &&
      this.dataDetailSkdp &&
      this.stateDataSkdp.length != 0 &&
      // this.stateDetailSkdp.signed == 0 &&
      this.stateuser.id == this.dataDetailSkdp["dokter"].id
    );
  }

  get listRujukanInternal() {
    return SuratKonsulRujukInternalStore.listRujuk;
  }

  get canAdd() {
    // update Mei 2026: bisa add skdp kalo bukan rujuk internal dan bukan penerima konsulan
    // direvisi 19-05-2026 karena rule konsul->skdp belum jelas
    return (
      this.stateuser.profesi == "Dokter" &&
      // !this.isPenerimaKonsulan && !this.isPengirimRujukanInternal
      !this.isPengirimRujukanInternal
    );
  }

  get isPenerimaKonsulan() {
    return SuratKonsulRujukInternalStore.isPenerimaKonsulan;
  }

  get isPengirimRujukanInternal() {
    return SuratKonsulRujukInternalStore.isPengirimRujukanInternal;
  }

  mounted() {
    storeSKDP.actSkdp_on_reg(this.register);
  }

  backPageSoap() {
    this.$emit("pageTab", this.pageTab);
  }

  passTtd(value) {
    appModule.setLoading(true);

    // console.log(value);
    const dt = DataSKDP.saveDataTtdSKDP(
      this.dataDetailSkdp["id"],
      this.dataDetailSkdp["dpjp_id"],
      value
    );
    dt.then(dt => {
      appModule.setLoading(false);
      // console.log(dt);
      if (dt["status"] != 1) {
        // console.log(dt["message"]);
        appModule.addMsgTtd(dt["data"]["message"]);
        this.modalTtd = true;
        // appModule.sendErrorAlert(dt["err"]);
      } else {
        appModule.NoticeDelay("Berhasil Tanda Tangan SKDP");
        this.modalTtd = false;
        appModule.addMsgTtd("");
        storeSKDP.actSKD_on_id(this.dataDetailSkdp["id"]);
        storeSKDP.actSkdp_on_reg(this.register);
      }
    });
  }

  cetakSKDP(id) {
    const routeData = http.getAPI() + "/skdp/" + id + "/pdf";
    window.open(routeData, "_blank");
  }

  editSKDP(val) {
    this.dataSkdp = val;
    // this.dataSkdp = this.stateDetailSkdp;
    // storeSKDP.actSkdp_on_reg(this.register);
    // this.modalSKDP = true;
    this.expandInput = true;
    // this.modalKasusSkdp = true;
  }

  deleting = false;

  deleteSKDP(id) {
    const q = confirm("Yakin menghapus SKDP ini?");

    if (q) {
      if (!this.deleting) {
        this.deleting = true;

        const resp = Skdp.destroy(id);

        resp
          .then(dt => {
            if (dt.status == "1") {
              storeSKDP.actSkdp_on_reg(this.register);
            }
          })
          .finally(() => {
            this.deleting = false;
          });
      } else {
        alert("masih ada proses menghapus skdp... coba refresh halaman!");
      }
    }
  }

  get inputTerbuka(): boolean {
    return this.expandInput || this.bukaDariPrefill;
  }

  showModalTtd() {
    this.modalTtd = true;
  }

  @Watch("prefillNonce", { immediate: true })
  onPrefill() {
    if (!this.prefill) return;

    this.$nextTick(() => {
      this.dataSkdp = {};
      this.kronis = false;
      this.prefillAktif = this.prefill;
      this.bukaDariPrefill = true;
    });
  }

  showModalKasus() {
    // storeSKDP.actSkdp_on_new();
    this.dataSkdp = {};
    // this.modalSKDP = true;
    // console.log("aaa");
    this.modalKasusSkdp = true;

    // this.modalTtd = true;
  }
  openInputSKDP() {
    this.dataSkdp = {};

    this.expandInput = true;
  }

  setKronis(val) {
    this.kronis = val;

    this.openInputSKDP();
  }

  formatTgl(value) {
    const dd = value.substr(0, 2);
    const mm = value.substr(3, 2);
    const yyyy = value.substr(6, 4);
    return yyyy + "-" + mm + "-" + dd;
  }

  getHumanDate(date) {
    return date ? moment(date).format("DD MMMM YYYY") : "";
  }

  getHumanDateTime(date) {
    return date ? moment(date).format("DD MMMM YYYY HH:mm:ss") : "";
  }
  closeExpand(v) {
    this.expandInput = v;
    this.bukaDariPrefill = false;
    this.prefillAktif = null;
  }

  tambah() {
    if (this.canAdd) {
      // this.kronis = false;
      this.dataSkdp = {};
      // this.modalSKDP = true;
      this.openInputSKDP();
    } else {
      // alert("Tidak bisa menambahkan SKDP karena pasien sudah dirujuk internal");

      // if (this.isPenerimaKonsulan) {
      //   appModule.sendErrorAlert(
      //     "Tidak bisa menambahkan SKDP untuk pasien konsulan"
      //   );
      // } else if (this.isPengirimRujukanInternal) {
      //   appModule.sendErrorAlert(
      //     "Tidak bisa menambahkan SKDP karena pasien sudah dirujuk internal"
      //   );
      // } else {
      //   appModule.sendErrorAlert("Tidak bisa menambahkan SKDP");
      // }

      if (this.isPengirimRujukanInternal) {
        appModule.sendErrorAlert(
          "Tidak bisa menambahkan SKDP karena pasien sudah dirujuk internal"
        );
      } else {
        appModule.sendErrorAlert("Tidak bisa menambahkan SKDP");
      }
    }
  }

  klikPanel(dt) {
    storeSKDP.SET_DATA_DETAIL_SKDP(dt);
  }

  cekSKDP(val) {
    if (val.length > 0) {
      if (this.filterSKDP(val).length > 0) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  filterSKDP(data) {
    return data.filter(val => val.dokter.id == this.stateuser.id);
  }
}
